<script lang="ts">
  export let size: any = '22';
</script>

<svg width={size} height={size} viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M8.6741 9.625H15.0908"
    class={$$props.class || "stroke-garden-grey-600"}
    stroke-width="1.5"
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M7.29912 16.8942H10.9658L15.045 19.6076C15.65 20.0109 16.4658 19.58 16.4658 18.8467V16.8942C19.2158 16.8942 21.0491 15.0609 21.0491 12.3109V6.81087C21.0491 4.06087 19.2158 2.22754 16.4658 2.22754H7.29912C4.54912 2.22754 2.71579 4.06087 2.71579 6.81087V12.3109C2.71579 15.0609 4.54912 16.8942 7.29912 16.8942Z"
    class={$$props.class || "stroke-garden-grey-600"}
    stroke-width="1.5"
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
